/**
 * GATING de draft por tiempo — cliente
 * - Si termina el contador visible ⇒ ocultamos draft.
 * - Si al cargar una draft ya está vencida ⇒ la ignoramos.
 * - Opcional: notificamos al backend para marcarla como 'expired'.
 */

(function () {
    // Lee slot desde la config (weekday/weekend)
    function getSlot() {
        const CFG = window.MOX_CFG || {};
        const fridayStart = (CFG.weekend_starts_on || 'friday') === 'friday';
        const d = new Date().getDay(); // 0 Dom, 5 Vie, 6 Sáb
        const isWeekend = fridayStart ? (d === 5 || d === 6 || d === 0) : (d === 6 || d === 0);
        return isWeekend
            ? { visible: Number(CFG.weekend_visible_hours || 48), real: Number(CFG.weekend_real_hours || 72) }
            : { visible: Number(CFG.weekday_visible_hours || 24), real: Number(CFG.weekday_real_hours || 40) };
    }

    // Calcula fin visible/real con preferencia por campos del backend (si existen)
    function computeEnds(draft) {
        const d = draft?.draftOrder || draft || {};
        const createdISO = d.createdAt || d.created_at;
        const created = createdISO ? new Date(createdISO).getTime() : Date.now();
        const slot = getSlot();

        const beVis = d.expiresAt_visible || d.expires_at_visible; // si backend ya los manda
        const beReal = d.expiresAt_real || d.expires_at_real;

        const visibleEnd = beVis ? new Date(beVis) : new Date(created + slot.visible * 3600000);
        const realEnd = beReal ? new Date(beReal) : new Date(created + slot.real * 3600000);

        return { visibleEnd, realEnd };
    }

    // Expira en cliente: oculta UI y avisa (opcional) al backend
    function expireDraftClientSide(reason = 'visible') {
        const d = window.MOX_DRAFT?.current?.draftOrder || window.MOX_DRAFT?.current || null;
        if (!d) return;

        try {
            if (window.MOX_API_BASE && (d.id || d.gid)) {
                const idNum = String(d.id || d.gid).replace(/\D/g, '');
                fetch(`${window.MOX_API_BASE}/draft-orders/${idNum}/expire?shop=babalu-b2b.myshopify.com`, {
                    method: 'POST',
                    headers: window.MOX_HEADERS(),
                    body: JSON.stringify({ reason })
                }).catch(() => { });
            }
        } catch (_) { }

        document.dispatchEvent(new CustomEvent('mox:draft:expired', { detail: { id: d.id || d.gid, reason } }));
        document.dispatchEvent(new CustomEvent('mox:draft:none'));
    }



    // 1) Si termina el contador visible → expira en cliente
    window.addEventListener('mox:reserve:visible_end', () => expireDraftClientSide('visible'));

    // 2) Al cargar/refrescar la draft, la filtramos por tiempo
    window.addEventListener('mox:draft:loaded', (e) => {
        //debugger
        const draft = e.detail?.draft?.draftOrder ?? e.detail?.draft ?? null;
        if (!draft) return;

        const { visibleEnd, realEnd } = computeEnds(draft);
        const now = Date.now();

        if (now > visibleEnd.getTime()) {
            // Para UI, la tratamos como expirada aunque el backend aún no la cancele.
            expireDraftClientSide('visible_on_load');
            return;
        }
        if (now > realEnd.getTime()) {
            // Por si llegamos a ver una draft que ya pasó el real_end
            expireDraftClientSide('real_on_load');
            return;
        }
    });

    // 3) Cuando no haya draft → cierra el panel (por si el tema no lo hace solo)
    // window.addEventListener('mox:draft:none', () => {
    //     const panel = document.querySelector('[data-mox-panel]');
    //     if (panel) panel.setAttribute('aria-hidden', 'true');
    //     const overlay = document.querySelector('[data-mox-overlay]');
    //     if (overlay) overlay.hidden = true;
    // });
})();

